import React, { useState } from 'react';
import { Shield, Package, MessageCircle, Settings, ChevronDown, Truck } from 'lucide-react';
import { useMyContext } from '../../../../context/MyContext';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';

const Integration = () => {
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleShopifyClick = () => {
    window.location.href = '/integration/sopify';
  };

  const handleWoocommerceClick = () => {
    window.location.href = '/integration/woocom';
  };

  const handleZohoClick = () => {
    window.location.href = '/integration/zoho';
  };


  // const api_doc_px = () => {
  //   window.location.href = '/integration/api_doc_px';

  // };


    const api_doc_px = () => {
    window.location.href = '/dashboard';
  
  };

  const handleCommunicationConfig = () => {
    window.location.href = '/intregration/communication';
  };


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}

        <div className={`flex-1 p-6 overflow-y-auto rounded-xl ${isDarkMode ? 'bg-darkmodeColor' : 'bg-gray-50'}`}>
          <div className="max-w-6xl mx-auto">
            <h1 className={`text-4xl font-bold mb-12 text-center ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Value Added Services
            </h1>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Pickup Protect Card */}
              <div className={`${isDarkMode ? 'bg-white/10 backdrop-blur-lg border-white/20' : 'bg-white border-gray-200'} shadow-lg rounded-2xl p-8 border hover:border-opacity-60 transition-all duration-300 hover:scale-105 hover:shadow-xl`}>
                <div className="flex items-center justify-between mb-6">
                  <div className={`p-3 rounded-xl ${isDarkMode ? 'bg-purple-500/20' : 'bg-purple-100'}`}>
                    <Truck className={`w-8 h-8 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                  </div>
                </div>

                <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Pickup Api Integration</h3>
                <p className={`mb-8 text-sm leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  Seamlessly integrate our Pickup API to schedule, manage, and track pickup requests in real time.
                  Automate pickup creation, receive instant status updates, and ensure smooth coordination between your system and logistics operations.
                </p>


                <button
                  onClick={api_doc_px}
                  className={`w-full ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border-white/20 hover:border-white/40' : 'bg-gray-100 hover:bg-gray-200 text-gray-800 border-gray-300 hover:border-gray-400'} font-semibold py-3 px-6 rounded-xl border transition-all duration-300 flex items-center justify-center gap-2`}>
                  <Settings className="w-4 h-4" />
                  Configure
                </button>
              </div>

              {/* Channel Integration Card */}
              <div className={`${isDarkMode ? 'bg-white/10 backdrop-blur-lg border-white/20' : 'bg-white border-gray-200'} shadow-lg rounded-2xl p-8 border hover:border-opacity-60 transition-all duration-300 hover:scale-105 hover:shadow-xl relative`}>
                <div className="flex items-center justify-between mb-6">
                  <div className={`p-3 rounded-xl ${isDarkMode ? 'bg-blue-500/20' : 'bg-blue-100'}`}>
                    <Package className={`w-8 h-8 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                  </div>
                </div>

                <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Channel Integration</h3>
                <p className={`mb-8 text-sm leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  Pre-integrated with Shopify and WooCommerce - your orders get auto-fetched by Pickupxpress
                </p>

                <div className="relative">
                  <button
                    onClick={() => setShowDropdown(!showDropdown)}
                    className={`w-full ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border-white/20 hover:border-white/40' : 'bg-gray-100 hover:bg-gray-200 text-gray-800 border-gray-300 hover:border-gray-400'} font-semibold py-3 px-6 rounded-xl border transition-all duration-300 flex items-center justify-center gap-2`}
                  >
                    <Settings className="w-4 h-4" />
                    Configure
                    <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${showDropdown ? 'rotate-180' : ''}`} />
                  </button>

                  {showDropdown && (
                    <div className={`absolute top-full left-0 right-0 mt-2 ${isDarkMode ? 'bg-gray-800/95 backdrop-blur-lg border-gray-600/50' : 'bg-white/95 backdrop-blur-lg border-gray-200'} rounded-xl border shadow-2xl overflow-hidden z-10`}>
                      <button
                        onClick={handleShopifyClick}
                        className={`w-full px-6 py-4 text-left ${isDarkMode ? 'text-gray-200 hover:bg-purple-500/20 hover:text-purple-300 border-gray-600/50' : 'text-gray-800 hover:bg-purple-500/20 hover:text-purple-800 border-gray-200/50'} transition-all duration-200 border-b flex items-center gap-3`}
                      >
                        <div className="w-6 h-6 bg-green-500 rounded flex items-center justify-center">
                          <span className="text-white text-xs font-bold">S</span>
                        </div>
                        Shopify
                      </button>
                      <button
                        onClick={handleWoocommerceClick}
                        className={`w-full px-6 py-4 text-left ${isDarkMode ? 'text-gray-200 hover:bg-purple-500/20 hover:text-purple-300' : 'text-gray-800 hover:bg-purple-500/20 hover:text-purple-800'} transition-all duration-200 flex items-center gap-3`}
                      >
                        <div className="w-6 h-6 bg-purple-600 rounded flex items-center justify-center">
                          <span className="text-white text-xs font-bold">W</span>
                        </div>
                        WooCommerce
                      </button>
                         <button
                        onClick={handleZohoClick}
                        className={`w-full px-6 py-4 text-left ${isDarkMode ? 'text-gray-200 hover:bg-purple-500/20 hover:text-purple-300' : 'text-gray-800 hover:bg-purple-500/20 hover:text-purple-800'} transition-all duration-200 flex items-center gap-3`}
                      >
                        <div className="w-6 h-6 bg-purple-600 rounded flex items-center justify-center">
                          <span className="text-white text-xs font-bold">Z</span>
                        </div>
                        Zoho
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Communications Card */}
              <div className={`${isDarkMode ? 'bg-white/10 backdrop-blur-lg border-white/20' : 'bg-white border-gray-200'} shadow-lg rounded-2xl p-8 border hover:border-opacity-60 transition-all duration-300 hover:scale-105 hover:shadow-xl`}>
                <div className="flex items-center justify-between mb-6">
                  <div className={`p-3 rounded-xl ${isDarkMode ? 'bg-green-500/20' : 'bg-green-100'}`}>
                    <MessageCircle className={`w-8 h-8 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`} />
                  </div>
                </div>

                <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Communications</h3>
                <p className={`mb-8 text-sm leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  Improve deliverability by informing your customers about real time shipment updates.
                </p>

                <button
                  onClick={handleCommunicationConfig}

                  className={`w-full ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border-white/20 hover:border-white/40' : 'bg-gray-100 hover:bg-gray-200 text-gray-800 border-gray-300 hover:border-gray-400'} font-semibold py-3 px-6 rounded-xl border transition-all duration-300 flex items-center justify-center gap-2`}>
                  <Settings className="w-4 h-4" />
                  Configure
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integration;
